module.exports = __webpack_public_path__ + "img/transform-your-business-ejaf-tech-canada-1.e23dfbf8.jpg";